import {FirestoreDocSnapshotWithIdAndData} from '@coolcolduk/firebase-util';
import {mapFirestoreDocWithTimestamp} from '../_other/firestore';
import {type JobDb} from './jobDbSchema';
import {Job, jobSchema} from './jobSchema';

export function mapJobDbToType(db: FirestoreDocSnapshotWithIdAndData<JobDb>): Job {
  const data = mapFirestoreDocWithTimestamp(db);
  return jobSchema.parse(data);
}
